import { styled } from '@stitches/configed';
import { motion } from 'framer-motion';
import CloseIcon from '../../Common/Icons/CloseIcon';

export const Container = styled(motion.div, {
  zIndex: 999,
  color: '#FFFFFFB2',
  backgroundColor: '#163559',
  padding: 16,
  transition: 'all 0.5s',
  variants: {
    collapse: {
      pcOpen: {
        width: 300,
      },
      pcClose: {
        width: 92,
      },
      mobileOpen: {
        left: 0,
      },
      mobileClose: {
        left: '-100%',
      },
    },
  },
});

export const LogoContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  height: 60,
  marginBottom: 16,
});

export const SidebarFooter = styled('div', {
  padding: '4px 0 12px 18px',
});
export const ButtonClose = styled(CloseIcon, {
  color: '#fff',
  cursor: 'pointer',
  fontSize: 32,
  display: 'none',
  variants: {
    isMobile: {
      true: {
        display: 'block',
      },
    },
  },
});
